import styled from '@emotion/styled';

import colors from './colors';

const Heading3 = styled('h3')`
  display: inline;
  color: ${colors.black};
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  margin: 0;
`;

export default Heading3;
